export const GET_POS_CUSTOMER_ID = 'GET_POS_CUSTOMER_ID';

export const GET_POS_CUSTOMER_ID_SUCCESS = 'GET_POS_CUSTOMER_ID_SUCCESS';

export const GET_POS_CUSTOMER_ID_FAILED = 'GET_POS_CUSTOMER_ID_FAILED';